<template>
    <bar :options="option" class="echarts" ref="echartsize" :auto-resize="true" theme="walden"></bar>
</template>

<script>
import bar from "vue-echarts";
require('echarts');//引入所有表
import '@/assets/js/walden'
export default {
  name: 'CompanyEchart',
    components: {
        bar
    },
    props: {
        date: String
    },
  data () {
    return {
        option : {
            color: ['#47BF37', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7'],
            backgroundColor: '#FFFFFF',
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                padding : [40 , 0 , 0 , 0],
                data : [
                    {
                    name: '供应商订单金额',
                    // 强制设置图形为圆。
                    icon: 'circle',
                }],
                // data: ['客户总数', '新增客户','跟进客户', '流失客户'],
            },
            grid : {
                left : '60px',
                top : '80px',
                right : '20px',
            },
            toolbox: {
                show: false,
                feature: {
                    magicType: {type: ['line', 'bar']},
                    saveAsImage: {}
                }
            },
            xAxis: {
                type: 'category',
                // boundaryGap: false,
                data: [],
                axisLabel: {    // 坐标轴标签
                    rotate: 30, // 旋转角度
                },
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}'
                },
            },
            series: [
                {
                    name: '供应商订单金额',
                    type: 'bar',
                    barWidth: 24,
                    smooth : true,
                    data: [],
                    itemStyle: {
                        normal: {
                            barBorderRadius:[3, 3, 0, 0], // 设置柱状图圆角
                        }
                    },
                    label: {
                        show: true,  // 显示标签
                        position: 'top',  // 标签位置（可省略，默认即为top）
                        formatter: '{c}'  // 显示原始数值（{c}表示当前值）
                    }
                }
            ]
        },
    }
  },
    created(){
        // this.GetEchatStatic();
    },
    mounted(){
        let that = this;
        this.$nextTick(() => {
            this.$refs.echartsize.resize();
        })
    },
    methods: {
        GetCompanyEchart(){
            let that = this;
            that.loading = true;
            that.$axios.post('/admin/company/getMonthChart',{date: ''})
                .then(function (e) {
                    if(e.code === 0) {
                        let data = e.data;
                        that.option.xAxis.data = data.categories;
                        // var nData = [];
                        // data.static.forEach((item) => {
                        //     if(item >=23000) {
                        //         nData.push({value: item, itemStyle: {color: '#2882FF'}},);
                        //     }else if(item >= 20000 && item < 23000){
                        //         nData.push({value: item, itemStyle: {color: '#FF6600'}},);
                        //     }else if(item >= 17000 && item < 20000) {
                        //         nData.push({value: item, itemStyle: {color: '#F9E649'}},);
                        //     }else if(item >= 13000 && item < 17000) {
                        //         nData.push({value: item, itemStyle: {color: '#47bf37'}},);
                        //     }else{
                        //         nData.push({value: item, itemStyle: {color: '#999999'}},);
                        //     }
                        // })
                        that.option.series[0].data = data.series_money;
                    }else{
                        that.$Message.error({ background: true,duration:3, content:e.msg});
                    }
                })
                .catch(function (e) {
                    that.$Message.error({ background: true,duration:3, content:'请求发送失败'});
                });
        },
        GetCompanyEcharts(date){
            let that = this;
            that.loading = true;
            that.$axios.post('/admin/company/getMonthChart',{date: date})
                .then(function (e) {
                    if(e.code == 0) {
                        let data = e.data;
                        that.option.xAxis.data = data.categories;
                        var nData = [];
                        // data.static.forEach((item) => {
                        //     if(item >=23000) {
                        //         nData.push({value: item, itemStyle: {color: '#2882FF'}},);
                        //     }else if(item >= 20000 && item < 23000){
                        //         nData.push({value: item, itemStyle: {color: '#FF6600'}},);
                        //     }else if(item >= 17000 && item < 20000) {
                        //         nData.push({value: item, itemStyle: {color: '#F9E649'}},);
                        //     }else if(item >= 13000 && item < 17000) {
                        //         nData.push({value: item, itemStyle: {color: '#47bf37'}},);
                        //     }else{
                        //         nData.push({value: item, itemStyle: {color: '#999999'}},);
                        //     }
                        // })
                        that.option.series[0].data = data.series_money;
                    }else{
                        that.$Message.error({ background: true,duration:3, content:e.msg});
                    }
                })
                .catch(function (e) {
                    that.$Message.error({ background: true,duration:3, content:'请求发送失败'});
                });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>



// WEBPACK FOOTER //
// src/components/echart/CompanyEchart.vue